var cibCss3 = ["32 32", "<path d='M30 2l-4 23-13.956 5-12.044-5 1.225-5.925h5.125l-0.5 2.538 7.275 2.775 8.381-2.775 1.175-6.069h-20.837l1-5.125h20.856l0.656-3.294h-20.837l1.019-5.125z'/>"];

export { cibCss3 };
//# sourceMappingURL=cib-css3.js.map
